export default __webpack_public_path__ + "static/favicon.ico";